import { useMessageContext } from '@consigli/hooks';
import { Finding } from '@consigli/types';
import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getBidGapsCustomMessage } from '@/util/bid-gaps-finding-message';

interface SummaryFindingRowProps {
  finding: Finding;
}

export const SummaryFindingRow: FC<SummaryFindingRowProps> = ({ finding }) => {
  const { t } = useTranslation();
  const messageContext = useMessageContext(finding);

  const customMessage = messageContext?.CUSTOM_MESSAGE;
  const displayText =
    (typeof customMessage === 'string' ? customMessage : undefined) ??
    getBidGapsCustomMessage(messageContext) ??
    (finding.messageTemplate ? t(finding.messageTemplate, { ...messageContext }) : undefined) ??
    finding.fileName ??
    String(finding.id);

  const [expanded, setExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsClamped(el.scrollHeight > el.clientHeight);
    }
  }, [displayText]);

  return (
    <li className="list-none bg-day-light-5 rounded-md border border-day-light-2 px-4 py-3 text-sm text-day-neutral-dark leading-relaxed flex items-start gap-3">
      <span className="flex flex-col items-start min-w-0 flex-1">
        <span
          ref={textRef}
          data-testid="finding-text"
          className={expanded ? undefined : 'line-clamp-3'}
        >
          {displayText}
        </span>
        {isClamped && (
          <button
            onClick={() => setExpanded((v) => !v)}
            className="mt-1.5 text-xs font-medium text-day-primary hover:underline cursor-pointer"
          >
            {expanded ? t('findings.show-less') : t('findings.show-more')}
          </button>
        )}
      </span>
    </li>
  );
};
